import React, { useEffect } from 'react';
import { MdOutlineCreditCard } from "react-icons/md";
import { MdArrowRightAlt } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";
import { useState } from "react";
import { Month, Day, Year, Country, State } from '../components/Select';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import './css/Checkout.css'


// Checkout component

const Checkout = () => {
    const { t } = useTranslation()

    const [isChange, setIsChange] = useState(false);
    const [newAddress, setNewAddress] = useState(false);


    const fnChange = () => {
        setIsChange(true);
    }


    const fnNewAddress = () => {
        setIsChange(false);
        setNewAddress(true);
    }

    useEffect(() => {
        const html = document.getElementsByTagName('html')[0];
        html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
        html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
        window.Webflow && window.Webflow.destroy();
        window.Webflow && window.Webflow.ready();
        window.Webflow && window.Webflow.require('ix2').init();
        document.dispatchEvent(new Event('readystatechange'))
    }, [])

    return (
        <>
            <div className='theme-bg'>
                <Navbar />
                <div className="checkout-page">
                    <div className='primary-width'>
                        <div className='heading'><h3 className='title'>{t("checkout")}</h3></div>

                        <div className='checkout'>

                            <div className='container '>
                                <div className='cart-grid-contaner'>
                                    <div item xs={12} md={6} className='col-12 col-md-6 shipping'>
                                        <div className='pricing-box'>
                                            <h4 className='pricing-name'>{t("shippingAddress")}</h4>
                                            <label>Test Test</label>
                                            <label>123 Main Street</label>
                                            <label>Anytown</label>
                                            <label>Anytown 12345</label>
                                            <label>USA</label>
                                            <div className='address-change-url'><a href='#' className='change' onClick={fnChange}>{t("change")}</a></div>
                                        </div>



                                        <div className='pricing-box'>
                                            <h4 className='pricing-name'>{t("shippingAddress")}</h4>
                                            <form>
                                                <div className="form-contaner">
                                                    <div item xs={12} md={6} className='col-12 col-md-6 lgrid'>
                                                        <input type='text' className="theme-inp  mb-2" placeholder={t("firstName")} />
                                                    </div>
                                                    <div item xs={12} md={6} className='col-12 col-md-6 rgrid'>
                                                        <input type='text' className="theme-inp mb-2" placeholder={t("lastName")} />
                                                    </div>

                                                    <div item xs={12} md={12} className='col-12 col-md-12'>
                                                        <Country name="country" className="theme-inp" />
                                                    </div>

                                                    <div item xs={12} md={12} className='col-12 col-md-12'>
                                                        <input type='text' className="theme-inp mb-2" placeholder={t("address")} />
                                                    </div>

                                                    <div item xs={12} md={12} className='col-12 col-md-12' >
                                                        <input type='text' className="theme-inp mb-2" placeholder={t("appartmentSuiteEtc")} />
                                                    </div>

                                                    <div item xs={12} md={12} className='col-12 col-md-12' >
                                                        <input type='text' className="theme-inp mb-2" placeholder={t("city")} />
                                                    </div>

                                                    <div item xs={12} md={6} className='col-12 col-md-6 lgrid'>
                                                        <State name="state" className="theme-inp" />
                                                    </div>
                                                    <div item xs={12} md={6} className='col-12 col-md-6 rgrid'>
                                                        <input type='text' className="theme-inp mb-2" placeholder={t("zip")} />
                                                    </div>

                                                    <div item xs={12} md={6} className='col-12 col-md-6 flex'>
                                                        <input type="checkbox" className='checkbox' /> <label>{t("setAsDefault")}</label>
                                                    </div>
                                                    <div item xs={12} md={6} className='col-12 col-md-6'>
                                                        <div className="align-right">

                                                            <div className='card-footer-button-wrapper'><button className="btn-apply-coupon" style={{minHeight : '45px'}}>{t("save")}</button><a href='#' className='change' onClick={fnChange}>{t("change")}</a></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>


                                        <div className='pricing-box'>
                                            <div className='saved-address'>
                                                <div className='default-div'>
                                                <span className='location-icon'><MdOutlineLocationOn /></span>
                                                <div className='default-btn'>{t("default")}</div>
                                                </div>

                                                <h5 className='pricing-name'>Test Test</h5>
                                                <p>123 Main Street</p>
                                                <p>Anytown</p>
                                                <p>Anytown 12345</p>
                                                <p>USA</p>
                                                <div className='btn-div'>
                                                    <button className='remove-btn'>{t("remove")}</button>
                                                    <button className='use-btn'>{t("useThisAddress")}</button>
                                                </div>
                                                
                                                
                                            </div>
                                            <div className='line'></div> 
                                            <button className='new-address' onClick={fnNewAddress}>{t("addNewAddress")}</button>


                                        </div>

                                        <div className='pricing-box'>
                                            <h4 className='pricing-name'>{t("shippingMethods")}</h4>
                                            <div className='shipping-method'>
                                                <input type="radio" className='radio-div' />
                                                <label>{t("standardShipping")}</label>
                                            </div>
                                            <div className='message-home'>
                                                <p>{t("myGiftMessageToYou")}</p>
                                                <textarea className='message-textarea'></textarea>
                                                <p>0/400</p>
                                            </div>
                                        </div>


                                        <div className='pricing-box'>
                                            <h4 className='pricing-name'>{t("paymentInfo")}</h4>
                                            <div className='payments'>
                                                <button className='add-card-home'>{t("addCard")}</button>
                                                <div className='payment-methods'>
                                                    <div className='payment-method'>
                                                        <input type="radio"  className="radio-div" name='payment' />

                                                        <label><MdOutlineCreditCard /> {t("commissionWallet")}</label>

                                                    </div>
                                                    <div className='payment-method'>
                                                        <input type="radio" className="radio-div" name='payment' />
                                                        <label><MdOutlineCreditCard /> {t("creditsWallet")}</label>
                                                    </div>
                                                    <div className='payment-method'>
                                                        <input type="radio" className="radio-div" name='payment' />
                                                        <label><MdOutlineCreditCard /> {t("payWithCrypto")}</label>
                                                    </div>
                                                </div>

                                                <button className="process-payment">{t("processPayment")}→</button>
                                                
                                            </div>
                                        </div>


                                    </div>
                                    <div item xs={12} md={6} className='home col-12 col-md-6 checkout-summary'>
                                        <div className='pricing-box'>
                                            <h4 className='pricing-name'>{t("todaysOrderSummary")}</h4>

                                            <div className="pricing-row">
                                                <label>{t("itemSubTotal")}</label>
                                                <label>$0.00</label>
                                            </div>

                                            <div className="pricing-row">
                                                <label>{t("total")}</label>
                                                <label>$0.00</label>
                                            </div>

                                            <div className="form-group">
                                                <input placeholder="Coupon Code" />
                                                <button className="btn-apply-coupon"            >
                                                    <label>{t('apply')}</label>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Checkout;